import React from 'react';
import { newsArticles } from '../mock/news';

const NewsSection = () => (
  <section id="noticias" className="w-full py-12 md:py-24 lg:py-32 bg-white dark:bg-gray-950">
    <div className="container px-4 md:px-6">
      <div className="flex flex-col items-center justify-center space-y-4 text-center">
        <h2 className="text-3xl font-bold tracking-tighter sm:text-4xl md:text-5xl text-gray-900 dark:text-gray-100">
          Novedades y Análisis del Sector
        </h2>
        <p className="max-w-[700px] text-gray-600 md:text-xl/relaxed lg:text-base/relaxed xl:text-xl/relaxed dark:text-gray-400">
          Explora nuestros artículos más recientes, análisis de expertos y las últimas tendencias que impactan el comercio exterior.
        </p>
      </div>
      <div className="mx-auto grid max-w-5xl items-start gap-8 py-12 sm:grid-cols-2 lg:grid-cols-3">
        {newsArticles.map((article) => (
          <div key={article.id} className="grid gap-4 p-8 rounded-2xl border border-gray-200 bg-white shadow-xl transition-all duration-300 hover:shadow-2xl hover:-translate-y-1 dark:border-gray-700 dark:bg-gray-800">
            <h3 className="text-2xl font-bold text-gray-900 dark:text-gray-100">{article.title}</h3>
            <p className="text-sm text-gray-500 dark:text-gray-400">{article.date}</p>
            <p className="text-gray-700 dark:text-gray-300">{article.excerpt}</p>
            <a href="#" className="text-indigo-700 hover:underline dark:text-teal-500 font-medium">Leer más</a>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default NewsSection;